import { Task } from "../types/task";

export const resolveMigrationUploadSource = (task: Pick<Task, "metadata">) =>
    task.metadata?.migrationSource ?? null;
